import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconSessions.module.css';

const IconSessions = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9998 18.7191C18.2473 18.7396 18.4977 18.75 18.7505 18.75C19.7988 18.75 20.8053 18.5708 21.7409 18.2413C21.7472 18.1617 21.7505 18.0812 21.7505 18C21.7505 16.3431 20.4073 15 18.7505 15C18.1228 15 17.5402 15.1927 17.0586 15.5222M17.9998 18.7191C17.9999 18.7294 17.9999 18.7397 17.9999 18.75C17.9999 18.975 17.9875 19.1971 17.9634 19.4156C16.2066 20.4237 14.1705 21 11.9999 21C9.82921 21 7.79315 20.4237 6.03638 19.4156C6.01226 19.1971 5.99988 18.975 5.99988 18.75C5.99988 18.7397 5.9999 18.7295 5.99996 18.7192M17.9998 18.7191C17.9939 17.5426 17.6493 16.4461 17.0586 15.5222M17.0586 15.5222C15.9927 13.8552 14.1253 12.75 11.9999 12.75C9.87467 12.75 8.00753 13.8549 6.94157 15.5216M6.94157 15.5216C6.46011 15.1925 5.87784 15 5.25061 15C3.59376 15 2.25061 16.3431 2.25061 18C2.25061 18.0812 2.25384 18.1617 2.26017 18.2413C3.1958 18.5708 4.20228 18.75 5.25061 18.75C5.50295 18.75 5.75287 18.7396 5.99996 18.7192M6.94157 15.5216C6.35058 16.4457 6.00586 17.5424 5.99996 18.7192M14.9999 6.75C14.9999 8.40685 13.6567 9.75 11.9999 9.75C10.343 9.75 8.99988 8.40685 8.99988 6.75C8.99988 5.09315 10.343 3.75 11.9999 3.75C13.6567 3.75 14.9999 5.09315 14.9999 6.75ZM20.9999 9.75C20.9999 10.9926 19.9925 12 18.7499 12C17.5072 12 16.4999 10.9926 16.4999 9.75C16.4999 8.50736 17.5072 7.5 18.7499 7.5C19.9925 7.5 20.9999 8.50736 20.9999 9.75ZM7.49988 9.75C7.49988 10.9926 6.49252 12 5.24988 12C4.00724 12 2.99988 10.9926 2.99988 9.75C2.99988 8.50736 4.00724 7.5 5.24988 7.5C6.49252 7.5 7.49988 8.50736 7.49988 9.75Z"
        stroke="#535763"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconSessions.defaultProps = {
  className: null,
  rootClassName: null,
};

IconSessions.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconSessions;
